var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "form-button-disabler",
    [
      _c(
        "field",
        {
          staticClass: "pb-2",
          attrs: {
            label: "Review Type",
            "error-text": _vm.showValidations ? _vm.validations.name : "",
          },
        },
        [
          _c("text-field", {
            model: {
              value: _vm.name,
              callback: function ($$v) {
                _vm.name = $$v
              },
              expression: "name",
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "field",
        {
          staticClass: "pb-2",
          attrs: {
            label: "Review Type Description",
            "error-text": _vm.showValidations
              ? _vm.validations.description
              : "",
          },
        },
        [
          _c("text-field", {
            model: {
              value: _vm.description,
              callback: function ($$v) {
                _vm.description = $$v
              },
              expression: "description",
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "flex" },
        [
          _c("div", { staticClass: "flex-grow" }),
          _vm._v(" "),
          _c(
            "btn",
            {
              on: {
                click: function ($event) {
                  return _vm.closeProp()
                },
              },
            },
            [_vm._v("Add New Review Type")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }